import { render } from "./StudiesUpload.vue?vue&type=template&id=0d9f82bd&scoped=true"
import script from "./StudiesUpload.vue?vue&type=script&lang=js"
export * from "./StudiesUpload.vue?vue&type=script&lang=js"

import "./StudiesUpload.vue?vue&type=style&index=0&id=0d9f82bd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9f82bd"]])

export default __exports__